<template>
    <v-card flat class="conteneurLead" id="conteneurLead" style="width: 100%;">
        <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
          <v-btn icon @click="$emit('justCloseDialog')"><v-icon class="white--text">close</v-icon></v-btn>
          <div class="title tf_title_dialog" v-html="titleDialog"></div>
          <v-spacer></v-spacer>
          <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="submitDialog()" class="white--text">{{ $t('submit') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="loading" class="text-xs-center ">
            <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
          </div>
          <div v-else>
            <span></span>
            <v-textarea
              box
              placeholder="exemple : Did the user have any reference numbers in the chat?"
              name="contentDialogQuestion"
              :label="this.$t('exportQuestion')"
              auto-grow
              :value='contentDialogQuestion'
              v-model="contentDialogQuestion"
            ></v-textarea>
            <v-textarea
              box
              placeholder="exemple : Reference = yes, no"
              name="contentDialogReponse"
              :label="this.$t('reponse')"
              auto-grow
              :value='contentDialogReponse'
              v-model="contentDialogReponse"
            ></v-textarea>
          </div>  
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeDialog()">{{ $t('no') }}</v-btn>
          <v-btn 
            color="primary"
            @click="submitDialog()"
          >{{ $t('save') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>



<script>
export default {
  props: {
    dataDialog: {
      type: Object,
      default: {}
    },
    titleDialog: {
      type: String,
      default: 'Confirmation'
    },
    modifDialog: {
      type: Boolean,
      default: false
    },
    closeDialogUniquement: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      contentDialogQuestion: '',
      contentDialogReponse: '',
      loading: false,
      oldVal: {}
    }
  },
  computed: {},
  mounted () {},
  updated () {},
  methods: {
    closeDialog () {
      if (!this.closeDialogUniquement) {
        this.$emit('justCloseDialog')
      } else {
        this.$emit('justCloseDialog')
      }
    },
    submitDialog () {
      // console.log('modifDialog', this.modifDialog)
      if (this.modifDialog) {
        const dataToPost = {
          new: {
            'q': this.contentDialogQuestion,
            'a': this.contentDialogReponse
          },
          old: {
            'q': this.oldVal.q,
            'a': this.oldVal.a
          }
        }
        this.$emit('modifAnalyse', dataToPost)
      } else {
        const dataToPost = {
          'q': this.contentDialogQuestion,
          'a': this.contentDialogReponse
        }
        this.$emit('addAnalyse', dataToPost)
      }
      // this.contentDialogQuestion = ''
      // this.contentDialogReponse = ''
    }
  },
  watch: {
    // detect quand il y a des data à modifier
    dataDialog: function (val, oldVal) {
      console.log('dataDialog val :', val)
      if (val) {
        this.contentDialogQuestion = val.q
        this.contentDialogReponse = val.a
        this.oldVal = val
      }
    }
  }
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialogAnalyseChat.vue